/**
 * Class-name composition for the ui kit.
 *
 * A plain `parts.join(" ")` is not enough. Every primitive in `ui.tsx` builds a
 * class list as `base + variant + size + caller className`, and the caller's
 * class is meant to win — but CSS resolves duplicates by *stylesheet* order, not
 * by the order of the `class` attribute. Tailwind emits `.w-full` after the
 * numeric width scale, so `cx("w-full", "w-12")` produced `"w-full w-12"` and the
 * element still rendered 100% wide. The same trap sits under `px-*` vs `p-*`,
 * `rounded-lg` vs `rounded-full`, and every other utility that shares a property
 * with a base token.
 *
 * `twMerge` drops the losing duplicate instead of emitting both, so last-wins
 * holds regardless of what Tailwind's output order happens to be. Classes it does
 * not recognize (our `shadow-card`, `animate-rise`, `bg-brand-600`) pass through
 * untouched — it only ever removes a class that a later class conflicts with.
 */
import { twMerge } from "tailwind-merge";

export function cx(...parts: Array<string | false | null | undefined>): string {
  return twMerge(parts);
}
